import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Drivers from "../../pages/SchoolDashboard/Driver";
import ParentsList from "../../pages/SchoolDashboard/parents/List";
import BusFee from "../../pages/admin/Configuration/BusFee";
import VehiclesList from "../../pages/SchoolDashboard/VehicleManagement/Vehicles";
import RegulatoryCompliances from "../../pages/SchoolDashboard/VehicleManagement/RegulatoryCompliance";
import Reviews from "../../pages/vender/Reviews";
import BusCharterList from "../../pages/SchoolDashboard/reservation/school/BusCharterList";
import BusingSubscriptionList from "../../pages/SchoolDashboard/reservation/school/BusingSubscriptionList";

import VendorBusCharterList from "../../pages/SchoolDashboard/reservation/vendor/BusCharterList";
import VendorBusingSubscriptionList from "../../pages/SchoolDashboard/reservation/vendor/BusingSubscriptionList";
import BankDetailsList from "../../pages/admin/bank-details/List";

import SchoolPaymentHistory from "../../pages/SchoolDashboard/PaymentHistory/SchoolPaymentHistory";

const SlugHandler = () => {
  const { t } = useTranslation();
  const { slug } = useParams();

  // LISTING DRIVERS FOR (ADMIN | VENDOR | SCHOOL)
  if (
    slug === "school-drivers" ||
    slug === "vendor-drivers" ||
    slug === "drivers"
  )
    return <Drivers />;

  // LISTING PARENTS FOR (ADMIN | VENDOR | SCHOOL)
  if (
    slug === "school-parents" ||
    slug === "vendor-parents" ||
    slug === "parents"
  )
    return <ParentsList />;

  // LISTING BUS FEE FOR (ADMIN | VENDOR | SCHOOL)
  if (
    slug === "school-bus-fee" ||
    slug === "vendor-bus-fee" ||
    slug === "bus-fee"
  )
    return <BusFee />;

  // LISTING VEHICLE FOR (ADMIN | SCHOOL | VENDOR)
  if (
    slug === "school-vehicles" ||
    slug === "vendor-vehicles" ||
    slug === "vehicles"
  )
    return <VehiclesList />;

  // LISTING VEHICLE REGULATORY COMPLIANCE FOR (ADMIN | SCHOOL | VENDOR)
  if (
    slug === "vendor-vehicle-documents" ||
    slug === "school-vehicle-documents" ||
    slug === "regulatory-compliance"
  )
    return <RegulatoryCompliances />;

  // LISTING RATING & REVIEWS API (FOR SCHOOL | VENDOR | SUPER ADMIN | PARENT)
  if (
    slug === "vendor-ratings" ||
    slug === "school-ratings" ||
    slug === "ratings-and-reviews"
  )
    return <Reviews />;

  // LISTING BUS CHARTER RESERVATION API (FOR SCHOOL | SUPER ADMIN)
  if (slug === "school-bus-charter" || slug === "my-bus-reservations")
    return <BusCharterList />;

  // LISTING BUSING SUBSCRIPTION RESERVATION API (FOR SCHOOL | SUPER ADMIN)
  if (
    slug === "school-busing-subscription" ||
    slug === "vendor-busing-subscription" ||
    slug === "my-busing-subscriptions" ||
    slug === "vendor-busing-subscriptions"
  )
    return <BusingSubscriptionList />;

  // LISTING BUS CHARTER RESERVATION API (FOR SCHOOL VENDOR | SUPER ADMIN)
  if (slug === "bus-charter-reservations" || slug === "transfer-bus-charter")
    return <VendorBusCharterList />;

  // LISTING BUSING SUBSCRIPTION RESERVATION API (FOR SCHOOL VENDOR | SUPER ADMIN)
  if (
    slug === "busing-subscriptions" ||
    slug === "transfer-busing-subscription"
  )
    return <VendorBusingSubscriptionList />;

  // LISTING BANKS API (FOR SUPER ADMIN)
  if (
    slug === "school-bank-details" ||
    slug === "vendor-bank-details" ||
    slug === "bank-details"
  )
    return <BankDetailsList />;

  // Admin: school-payment-history, vendor-payment-history, parent-payment-history
  // All use SchoolPaymentHistory — role slug drives the data + column set
  if (
    slug === "school-payment-history" ||
    slug === "vendor-payment-history" ||
    slug === "parent-payment-history"
  )
    return <SchoolPaymentHistory />;

  return <div>{t("page_not_found")}</div>;
};

export default SlugHandler;
